import React, { Component } from 'react';

const styles = {
	container: {
    position: 'absolute',
    bottom: 0,
		display: 'flex',
		width: '100%',
		borderTop: 'solid 1px #000000',
		minHeight: '56px',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 10%',
    justifyContent: 'space-between'
	},
	item: {
    padding: '12px',
    color: 'black',
	}
};

class Footer extends Component {
	render() {
		return (
			<div style={styles.container}>
				<div style={styles.item}>
					{`© ${new Date().getFullYear()} MuseLab, LLC`}
				</div>
				<div style={styles.item}>
					<a href="mailto:support@muselab.io">
            SUPPORT@MUSELAB.IO
					</a>
				</div>
			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js